import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { grayDark } from '@bufferapp/ui/style/colors'

import { AppContext } from '~/app/providers/App'
import { Dropdown, Text, Label } from '~/shared/components'
import { Count, LabelCounter, LabelName } from './styles'

const COUNTER_LIMIT = 10000

/**
 *
 */
// @ts-expect-error TS(7031) FIXME: Binding element 'channel' implicitly has an 'any' ... Remove this comment to see the full error message
const ChannelCounters = ({ channel }) => {
  // @ts-expect-error TS(2339) FIXME: Property 'onFilter' does not exist on type 'unknow... Remove this comment to see the full error message
  const { onFilter } = useContext(AppContext)

  if (!channel) {
    return null
  }

  const { labelsCount, totalPendingComments } = channel

  let message = 'Unanswered comments'
  if (totalPendingComments === 0) {
    message += ' 🎉'
  }

  return (
    <Dropdown>
      <Dropdown.Button>
        {/* @ts-expect-error TS(2741) FIXME: Property 'className' is missing in type '{ childre... Remove this comment to see the full error message */}
        <Text
          size={14}
          weight={500}
          color={grayDark}
          data-testid="channel-counter"
        >
          <Count>
            {totalPendingComments > COUNTER_LIMIT
              ? '10k+'
              : totalPendingComments}
          </Count>
          {message}
        </Text>
      </Dropdown.Button>
      <Dropdown.List>
        {labelsCount && labelsCount.length > 0 && (
          <Dropdown.Section name="Filter grid by">
            {/* @ts-expect-error TS(7031) FIXME: Binding element 'label' implicitly has an 'any' ty... Remove this comment to see the full error message */}
            {labelsCount.map(({ label, count }, index) => (
              <Dropdown.Item
                clickable={count > 0}
                key={index}
                onClick={() => onFilter(label)}
              >
                <LabelCounter
                  data-testid={`${label.toLowerCase()}-label-counter`}
                >
                  <LabelName>
                    <Label type={label} />
                    {label.toLowerCase()}
                  </LabelName>
                  <Count>{count}</Count>
                </LabelCounter>
              </Dropdown.Item>
            ))}
          </Dropdown.Section>
        )}
      </Dropdown.List>
    </Dropdown>
  )
}

ChannelCounters.propTypes = {
  channel: PropTypes.object,
}

ChannelCounters.defaultProps = {
  channel: null,
}

export default ChannelCounters
